// extracted by mini-css-extract-plugin
export default {"eligibility":"Zl-z"};